import apiClient from "../../../utilities/apiClient";

export const signin = (payload) => {
  return apiClient.post(`${apiClient.Urls.signin}`, payload);
};

export const tenantCheck = (payload) => {
  return apiClient.get(`${apiClient.Urls.check_tenant}`, payload);
};

export const samlExchange = () => {
  return apiClient.get(`${apiClient.Urls.samlExchange}`);
};

export const samlLogout = () => {
  return apiClient.get(`${apiClient.Urls.samlLogout}`);
};
